import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcNotification(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.25c4.193 0 7.556 3.49 7.556 7.75v3.809l1.289 2.35a1.75 1.75 0 0 1-1.534 2.591h-3.136a4.31 4.31 0 0 1-8.35 0H4.69a1.75 1.75 0 0 1-1.534-2.592l1.289-2.35V10c0-4.26 3.363-7.75 7.555-7.75m-2.474 16.5a2.693 2.693 0 0 0 4.948 0zM12 3.75c-3.324 0-6.055 2.778-6.055 6.25v4a.75.75 0 0 1-.093.36L4.47 16.88a.25.25 0 0 0 .22.37h14.62a.25.25 0 0 0 .22-.37l-1.381-2.52a.75.75 0 0 1-.093-.36v-4c0-3.472-2.731-6.25-6.056-6.25",
    clipRule: "evenodd"
  }));
}
var IcNotification = createNolIcon(/*#__PURE__*/forwardRef(SvgIcNotification));

export { IcNotification as I };
